import { gql } from '@apollo/client/core'

export const ADD_TRADE_STOCK = gql`
  mutation AddTradeStock($input: TradeStockInput!) {
    addTradeStock(input: $input) {
      stock_id
      qty
      avg_price
      market_price
    }
  }
`

export const UPDATE_TRADE_STOCK = gql`
  mutation UpdateTradeStock($trade_stock_id: Int!, $input: TradeStockInput!) {
    updateTradeStock(trade_stock_id: $trade_stock_id, input: $input) {
      trade_stock_id
      stock_id
      qty
      avg_price
      market_price
    }
  }
`

export const DELETE_TRADE_STOCK = gql`
  mutation DeleteTradeStock($trade_stock_id: Int!) {
    deleteTradeStock(trade_stock_id: $trade_stock_id)
  }
`